export default __webpack_public_path__ + "static/media/ishat.21f645b3.png";